import { makeStyles } from "@material-ui/core/styles";
import { COLORS } from "./theme";

const globalStyles = makeStyles(() => ({
  colorPrimary: {
    color: COLORS.RED
  },
  textBlack50: {
    color: COLORS.BLACK,
    opacity: 0.5
  },
  fontWeightBold: {
    fontWeight: 700
  },
  textCenter: {
    textAlign: "center"
  },
  disableTextTransform: {
    textTransform: "none"
  },
  spinner: {
    position: "absolute",
    top: "50%",
    left: "50%",
    margin: 0,
    transform: "translate(-50%, -50%)"
  },
  center: {
    position: "absolute",
    top: "50%",
    left: "50%",
    margin: 0,
    transform: "translate(-50%, -50%)"
  },
  pl3: {
    paddingLeft: "1rem"
  },
  pr3: {
    paddingRight: "1rem"
  },
  button: {
    fontSize: 18,
    fontWeight: 500,
    borderRadius: 12,
    padding: "15px 35px",
    margin: "10px 10px 30px 10px"
  },
  btnPrimary: {
    fontFamily: "Montserrat,sans-serif",
    fontWeight: 700,
    textTransform: "uppercase",
    fontKerning: "none",
    color: "#fff",
    backgroundColor: COLORS.RED,
    padding: "20px 40px",
    border: "none",
    borderRadius: 0,
    transition: "background-color 0.25s",
    "&:hover": {
      backgroundColor: COLORS.DARKRED
    }
  },
  btnSecondary: {
    fontFamily: "Montserrat,sans-serif",
    fontWeight: 700,
    textTransform: "uppercase",
    fontKerning: "none",
    color: "#fff",
    backgroundColor: COLORS.GOLD,
    padding: "20px 40px",
    border: "none",
    borderRadius: 0,
    transition: "background-color 0.25s",
    "&:hover": {
      backgroundColor: COLORS.DARKGOLD
    }
  },
  btnTertiary: {
    fontFamily: "Montserrat,sans-serif",
    fontWeight: 700,
    textTransform: "uppercase",
    fontKerning: "none",
    color: "#fff",
    padding: 0,
    transition: "color 0.25s",
    "&:hover": {
      color: COLORS.RED
    }
  },
  btnOutlined: {
    fontFamily: "Montserrat,sans-serif",
    fontWeight: 700,
    textTransform: "uppercase",
    fontKerning: "none",
    color: COLORS.RED,
    backgroundColor: "transparent",
    border: "1px solid #c73b3b",
    borderRadius: 0,
    padding: "15px 20px",
    transition: "background-color 0.25s",
    "&:hover": {
      color: COLORS.RED
    }
  },
  btnIcon: {
    marginLeft: 10
  }
}));

export default globalStyles;
